import { Tooltip } from '@/ui'
import { InfoCircle } from '@dashboard/ui'

export const SuperAdminInfo = () => {
  return (
    <Tooltip message="Only for super admin">
      <InfoCircle className="text-text-error-primary" />
    </Tooltip>
  )
}
